export enum WidgetType {
  Chart = "chart",
  Table= "table",
  Kpi="kpi",
  Text = "text",
  Progress = "progress"
}